<script setup lang="ts">
import { PhxsgPicture, type PhxsgPictureProps } from '@sg/src/View/Components/Atoms/Picture';
import { getThemeVariant } from '@phx-styleguides/als';
import { computed } from 'vue';
import PhxsgPictureContent from '@sg-core/src/View/Components/Atoms/Picture/phxsg-picture-content.vue';

interface PhxPictureProps extends PhxsgPictureProps {
  variants?: {
    [key: string]: PhxsgPictureProps;
  };
}

const props = defineProps<PhxPictureProps>();

const hasLumenTheme = getThemeVariant(document) !== null;

const hasLumenVariant = computed(() => hasLumenTheme && props.variants?.lumen);

const attributes = computed(() => {
  return {
    ...props,
    variants: undefined,
    pictureAttrs: hasLumenVariant.value
      ? {
          'data-tv-match': 'day',
          'data-tv-fallback': true,
        }
      : undefined,
    'data-tv-container': hasLumenVariant.value ? true : undefined,
    'data-tv-layout': hasLumenVariant.value ? 'stacked' : undefined,
  };
});
</script>

<template>
  <PhxsgPicture v-bind="attributes">
    <template v-if="hasLumenVariant" #variant>
      <PhxsgPictureContent v-bind="variants?.lumen" data-tv-match="night" />
    </template>
  </PhxsgPicture>
</template>
